/* eslint-disable no-undef */
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { MDBIcon, MDBBtn, MDBBtnGroup } from "mdbreact";
import Shuffle from "shufflejs";
import PropTypes from "prop-types";

import CardCurso from "../CardCurso/CardCurso";
import { ConvertInstitutoToArea } from "../../helpers/Formatters";
import { GGgetMode } from "../../services/gglocalstorage";
import "./FiltroCurso.css";

export default class FiltroCurso extends React.Component {
	constructor(props) {
		super(props);
		this.cursos = props.cursos;
		this.state = {
			tiposFiltroVisible: false,
			titulacaoFiltroVisible: false,
			modalidadeFiltroVisible: false,
		};
	}

	toggleTiposFiltro = () => {
		this.setState((prevState) => ({
			tiposFiltroVisible: !prevState.tiposFiltroVisible,
		}));
	};

	toggleTitulacaoFiltro = () => {
		this.setState((prevState) => ({
			titulacaoFiltroVisible: !prevState.titulacaoFiltroVisible,
		}));
	};

	toggleModalidadeFiltro = () => {
		this.setState((prevState) => ({
			modalidadeFiltroVisible: !prevState.modalidadeFiltroVisible,
		}));
	};

	componentDidMount() {
		// --- NOVO BLOCO: verifica se existe parâmetro de modalidade na URL ---
		const params = new URLSearchParams(window.location.search);
		const modalidadeParam = params.get("modalidade");

		// Função auxiliar para aplicar o filtro após o carregamento
		const aplicarFiltroModalidade = () => {
			const btns = document.querySelectorAll(
				"#cursos-modalidade-filtro button"
			);
			btns.forEach((btn) => {
				const data = btn.getAttribute("data-modalidade");
				if (
					(modalidadeParam === "Presencial" && data === "Híbrido") ||
					data.toLowerCase() === modalidadeParam?.toLowerCase()
				) {
					btn.classList.add("active");
					btn.click(); // dispara o filtro visual e funcional
				}
			});
		};

		// Aguarda um pouco para garantir que os botões estejam montados no DOM
		if (modalidadeParam) {
			setTimeout(aplicarFiltroModalidade, 600);
		}

		// --- Lógica de filtragem com Shuffle ---
		class CustomFilter {
			constructor(element) {
				this.shuffle = new Shuffle(element, {
					easing: "cubic-bezier(0.165, 0.840, 0.440, 1.000)",
					gutterWidth: 0,
				});

				this.tipos = Array.from(
					document.querySelectorAll("#cursos-tipo-filtro button")
				);
				this.modalidades = Array.from(
					document.querySelectorAll("#cursos-modalidade-filtro button")
				);
				this.titulacoes = Array.from(
					document.querySelectorAll("#cursos-titulacao-filtro button")
				);

				this.filters = {
					tipos: [],
					modalidades: [],
					titulacoes: [],
				};

				this.searchBar = document.querySelector("#cursos-busca-filtro");
				this.shuffle.on(Shuffle.EventType.LAYOUT, function (e) {
					if (e.shuffle.visibleItems === 0) console.log("Nothing found");
				});

				this._bindEventListeners();
			}

			_bindEventListeners() {
				this._onTipoChange = this._handleTipoChange.bind(this);
				this._onModalidadeChange = this._handleModalidadeChange.bind(this);
				this._onTitulacaoChange = this._handleTitulacaoChange.bind(this);

				this.tipos.forEach((button) =>
					button.addEventListener("click", this._onTipoChange)
				);
				this.modalidades.forEach((button) =>
					button.addEventListener("click", this._onModalidadeChange)
				);
				this.titulacoes.forEach((button) =>
					button.addEventListener("click", this._onTitulacaoChange)
				);

				this.searchBar.addEventListener(
					"keyup",
					this._handleSearchKeyup.bind(this)
				);
			}

			_getCurrentTipoFilters() {
				return this.tipos
					.filter((button) => button.classList.contains("active"))
					.map((button) => button.getAttribute("data-tipo"));
			}

			_handleTipoChange(evt) {
				const button = evt.currentTarget;
				document.querySelector("#cursos-tipo-filtro").value = "";
				this.tipos.forEach((btn) => btn.classList.remove("active"));
				if (!button.classList.contains("active"))
					button.classList.add("active");
				this.filters.tipos = this._getCurrentTipoFilters();
				this.filter();
			}

			_getCurrentModalidadeFilters() {
				return this.modalidades
					.filter((button) => button.classList.contains("active"))
					.map((button) => button.getAttribute("data-modalidade"));
			}

			_handleModalidadeChange(evt) {
				const button = evt.currentTarget;
				document.querySelector("#cursos-modalidade-filtro").value = "";
				this.modalidades.forEach((btn) => btn.classList.remove("active"));
				if (!button.classList.contains("active"))
					button.classList.add("active");
				this.filters.modalidades = this._getCurrentModalidadeFilters();
				this.filter();
			}

			_getCurrentTitulacaoFilters() {
				return this.titulacoes
					.filter((button) => button.classList.contains("active"))
					.map((button) => button.getAttribute("data-titulacao"));
			}

			_handleTitulacaoChange(evt) {
				const button = evt.currentTarget;
				document.querySelector("#cursos-titulacao-filtro").value = "";
				this.titulacoes.forEach((btn) => btn.classList.remove("active"));
				if (!button.classList.contains("active"))
					button.classList.add("active");
				this.filters.titulacoes = this._getCurrentTitulacaoFilters();
				this.filter();
			}

			filter() {
				if (this.hasActiveFilters()) {
					this.shuffle.filter(this.itemPassesFilters.bind(this));
				} else {
					this.shuffle.filter(Shuffle.ALL_ITEMS);
				}
			}

			hasActiveFilters() {
				return Object.keys(this.filters).some(
					(key) => this.filters[key].length > 0
				);
			}

			itemPassesFilters(element) {
				const { tipos, modalidades, titulacoes } = this.filters;
				const tipo = element.getAttribute("data-tipo");
				const modalidade = element.getAttribute("data-modalidade");
				const titulacao = element.getAttribute("data-titulacao");

				if (tipos.length > 0 && !tipo.includes(tipos)) return false;
				if (titulacoes.length > 0 && !titulacao.includes(titulacoes))
					return false;

				if (modalidades.length > 0) {
					if (modalidades[0].indexOf("/") > 0) {
						if (
							!modalidades[0].split("/").some((x) => modalidade.includes(x))
						) {
							return false;
						}
					} else if (!modalidade.includes(modalidades)) {
						return false;
					}
				}
				return true;
			}

			_handleSearchKeyup(evt) {
				const searchText = evt.target.value
					.toLowerCase()
					.normalize("NFD")
					.replace(/[\u0300-\u036f]/g, "");

				this.shuffle.filter(function (element) {
					const titleElement = element.getAttribute("data-name");
					const titleText = titleElement
						.normalize("NFD")
						.replace(/[\u0300-\u036f]/g, "")
						.toLowerCase()
						.trim();

					return titleText.indexOf(searchText) !== -1;
				});
			}
		}

		// Instancia o filtro principal
		new CustomFilter(document.getElementById("cursos-items-container"));
	}

	render() {
		return (
			<Container fluid className="mt-1">
				{/* Campo de busca */}
				<Row className="text-center mx-lg-4">
					<Col>
						<div className="input-group md-form form-1 pl-0">
							<div className="input-group-prepend">
								<span className="input-group-text bg-secondary" id="basic-text1">
									<MDBIcon className="text-white" icon="search" />
								</span>
							</div>
							<input
								className={
									"form-control my-0 py-1" + (GGgetMode() ? " text-white" : "")
								}
								aria-label="Pesquisar"
								id="cursos-busca-filtro"
								type="text"
								placeholder="Pesquisar"
							/>
						</div>
					</Col>
				</Row>

				{/* Filtros de tipo */}
				<Row className="text-center my-2">
					<Col>
						<h4
							className="my-auto pr-2 text-secondary"
							onClick={this.toggleTiposFiltro}
						>
							Eu busco por <MDBIcon fas icon="angle-down" />
						</h4>
						<MDBBtnGroup
							size="middle"
							className={`btn-group-filtro flex-wrap ${
								this.state.tiposFiltroVisible ? "" : "hidden"
							}`}
							id="cursos-tipo-filtro"
						>
							{[
								["criatividade e tecnologia", "icct-background"],
								["saúde", "ics-background"],
								["humanidades e sociais", "ichs-background"],
							].map((item) => (
								<MDBBtn
									color="primary"
									className={item[1]}
									data-tipo={item[0]}
									key={item[0]}
									style={{ marginLeft: "0px", color: "#fff" }}
								>
									{item[0]}
								</MDBBtn>
							))}
						</MDBBtnGroup>
					</Col>
				</Row>

				{/* Filtro de grau */}
				<Row className="text-center my-2">
					<Col>
						<h4
							className="my-auto pr-2 text-secondary"
							onClick={this.toggleTitulacaoFiltro}
						>
							Grau <MDBIcon fas icon="angle-down" />
						</h4>
						<MDBBtnGroup
							size="middle"
							className={`btn-group-filtro flex-wrap ${
								this.state.titulacaoFiltroVisible ? "" : "hidden"
							}`}
							id="cursos-titulacao-filtro"
						>
							{["Bacharelado", "Licenciatura", "Tecnólogo"].map((item) => (
								<MDBBtn
									outline
									color={!GGgetMode() ? "secondary" : "gg"}
									className="mx-1"
									data-titulacao={item}
									key={item}
								>
									{item}
								</MDBBtn>
							))}
						</MDBBtnGroup>
					</Col>
				</Row>

				{/* Filtro de formato (modalidade) */}
				<Row className="text-center my-2">
					<Col>
						<h4
							className="my-auto pr-2 text-secondary"
							onClick={this.toggleModalidadeFiltro}
						>
							Formato <MDBIcon fas icon="angle-down" />
						</h4>
						<MDBBtnGroup
							size="middle"
							className={`btn-group-filtro flex-wrap ${
								this.state.modalidadeFiltroVisible ? "" : "hidden"
							}`}
							id="cursos-modalidade-filtro"
						>
							{["Presencial", "EAD", "Semipresencial"].map((item) => (
								<MDBBtn
									outline
									color={!GGgetMode() ? "#fff" : "gg"}
									className="mx-1 bg-primary text-white"
									data-modalidade={item}
									key={item}
								>
									{item}
								</MDBBtn>
							))}
						</MDBBtnGroup>
						<hr className="mt-3 mb-1" />
					</Col>
				</Row>

				{/* Itens de curso */}
				<Row id="cursos-items-container" className="no-gutters">
					{this.props.cursos.map((curso) => (
						<Col
							md="4"
							key={curso.Title}
							data-tipo={ConvertInstitutoToArea(curso.Instituto)}
							data-modalidade={curso.Opcoes}
							data-titulacao={curso.Opcoes}
							data-name={curso.Title}
						>
							<CardCurso
								key={curso.Title}
								slug={curso.Slug}
								instituto={ConvertInstitutoToArea(curso.Instituto)}
								tagEventos={curso.Items[0]?.Integracao?.TagsEventos?.Value}
								opcoes={curso.Opcoes}
								name={curso.Title}
							/>
						</Col>
					))}
				</Row>
			</Container>
		);
	}
}

FiltroCurso.propTypes = {
	cursos: PropTypes.array.isRequired,
};
